import { getCurrentBasic } from './core/ProgramService'

/**
 *
 * @description 视频直播 - 浏览
 */
export async function reportVideoLiveView(params: { videoLiveId: string; videoLiveTitle: string }) {
    window['sensors'].track(
        'KbPGCObjUserAct',
        Object.assign(await getCurrentBasic(), {
            business: 'VIDEO_LIVE',
            businessVer: 1,
            pageName: '视频直播页',
            pageUrl: window.location.href,

            ref1Name: '视频直播',
            ref1: params.videoLiveId,
            ref1Title: params.videoLiveTitle,

            view: 1,
        }),
    )
}
